<form [formGroup]="form">
  <div hlmField>
    <label for="input-nom" hlmFieldLabel labelRequired>Nom</label>
    <input id="input-nom" hlmInput type="text" formControlName="nom" />
    @if (form.get('nom')?.invalid && form.get('nom')?.touched) {
      <hlm-field-error>Le nom doit être renseigné.</hlm-field-error>
    }
  </div>
</form>
